import React from "react";

export const RefreshIcon = ({ size, fill }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 512 512"
    >
      <path
        fill={fill}
        d="M32.05 256.1c0 123.5 100.4 223.9 223.9 223.9c104.4 0 180-76.8 180-95.94c0-9.377-7.705-16.03-15.98-16.03C399.5 367.1 369.3 448 256 448c-105.9 0-192-86.13-192-192s86.13-192 192-192c75.11 0 123.1 44.4 124.2 45.15l-55.54 55.54c-3.055 3.055-4.681 7.16-4.681 11.33C320 184.9 327.2 192 336 192h128C472.8 192 480 184.8 480 176v-128c0-8.606-6.901-15.97-15.97-15.97c-4.171 0-8.291 1.598-11.35 4.653L402.1 87.32c-8.646-13.15-70.2-55.25-146.1-55.25C132.4 32.07 32.05 132.6 32.05 256.1zM374.6 160L448 86.63V160H374.6z"
      />
    </svg>
  );
};
